(() => {
 const init = () => document.querySelectorAll('[data-vics-mobile-pages]').forEach(nav => {
  if(nav.dataset.initialized) return;
  nav.dataset.initialized='true';
  const show = (name,focus=true) => {
   nav.querySelectorAll('[data-vics-mobile-page]').forEach(panel => {panel.hidden=panel.dataset.vicsMobilePage!==name;});
   const current=nav.querySelector(`[data-vics-mobile-page="${name}"]`);
   if(focus) current?.querySelector('button,a,summary')?.focus();
   const scroller=nav.closest('.vics-mobile-drawer__panel');
   if(scroller) scroller.scrollTop=0;
  };
  nav.addEventListener('click',event=>{const button=event.target.closest('[data-vics-mobile-go]');if(button){event.preventDefault();show(button.dataset.vicsMobileGo);}});
  nav.closest('[data-vics-mobile-navigation]')?.addEventListener('toggle',event=>{if(!event.target.open)show('root',false);});
 });
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
